/**
 * The 7 "format" cards used to each open their own full copy of this modal
 * (title + links + the same 11 catalog images, repeated every time) — one
 * of the bigger chunks of DOM bloat hurting LCP/Speed Index in Lighthouse's
 * mobile lab test. There's now a single #subject-modal in the markup; this
 * fills in its title/links/data-subject from whichever card was clicked,
 * matching what courses.scss now keys its per-subject styling on.
 *
 * Runs in the capture phase specifically so it fills the content in BEFORE
 * MicroModal's own (bubble-phase) click handler makes the modal visible —
 * otherwise there'd be a flash of the previous card's content.
 */
function initSubjectModal() {
	const modal = document.getElementById("subject-modal");
	if (!modal) return;

	const titleEl = modal.querySelector(".math-modal__title");
	const gridEl = modal.querySelector(".math-modal__grid");

	document.addEventListener(
		"click",
		(event) => {
			const trigger = event.target.closest(
				'[data-modal-open="subject-modal"]',
			);
			if (!trigger) return;

			modal.dataset.subject = trigger.dataset.modalSubject || "";

			if (titleEl) {
				titleEl.textContent = trigger.dataset.modalTitle || "";
			}

			if (gridEl) {
				gridEl.innerHTML = "";
				let links = [];
				try {
					links = JSON.parse(trigger.dataset.modalLinks || "[]");
				} catch (e) {
					links = [];
				}
				links.forEach((link) => {
					if (!link || !link.url) return;
					const a = document.createElement("a");
					a.className = "math-modal__btn";
					a.href = link.url;
					a.textContent = link.text || "Перейти";
					gridEl.appendChild(a);
				});
			}
		},
		true,
	);
}

document.addEventListener("DOMContentLoaded", () => {
	initSubjectModal();

	document.querySelectorAll(".benefits-swiper--mobile").forEach(initPager);

	function initPager(root) {
		const scope = root.parentElement || document;
		const prevBtn = scope.querySelector(".button-prev");
		const nextBtn = scope.querySelector(".button-next");
		const pagEl = scope.querySelector(".pagination-course");
		if (!prevBtn || !nextBtn || !pagEl) return;

		const PAGES = 4;
		let pageIndex = 0;
		const bullets = [];

		const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
		const maxScroll = () =>
			Math.max(0, root.scrollWidth - root.clientWidth);
		const indexToLeft = (i) => {
			const m = maxScroll();
			if (m === 0) return 0;
			return Math.round((m * i) / (PAGES - 1));
		};
		const leftToIndex = (left) => {
			const m = maxScroll();
			if (m === 0) return 0;
			const ratio = left / m;
			return clamp(Math.round(ratio * (PAGES - 1)), 0, PAGES - 1);
		};

		const updateUI = () => {
			bullets.forEach((b, i) => {
				const active = i === pageIndex;
				b.classList.toggle("pagination-bullet-active", active);
				if (active) b.setAttribute("aria-current", "true");
				else b.removeAttribute("aria-current");
			});
			const atStart = pageIndex === 0;
			const atEnd = pageIndex === PAGES - 1;
			prevBtn.classList.toggle("button-disabled", atStart);
			nextBtn.classList.toggle("button-disabled", atEnd);
		};

		pagEl.innerHTML = "";
		for (let i = 0; i < PAGES; i++) {
			const b = document.createElement("span");
			b.className = "pagination-bullet";
			b.tabIndex = 0;
			b.setAttribute("role", "button");
			b.setAttribute("aria-label", `Go to page ${i + 1}`);
			b.addEventListener("click", () => scrollToIndex(i));
			pagEl.appendChild(b);
			bullets.push(b);
		}

		let programmaticTarget = null;
		let settleTimer = null;
		const SETTLE_MS = 280;
		const EPS = 2;

		const prefersNoMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;

		const scrollToIndex = (i, smooth = true) => {
			pageIndex = clamp(i, 0, PAGES - 1);
			programmaticTarget = indexToLeft(pageIndex);

			root.scrollTo({
				left: programmaticTarget,
				behavior: smooth && !prefersNoMotion ? "smooth" : "auto",
			});

			updateUI();

			if (settleTimer) clearTimeout(settleTimer);
			settleTimer = setTimeout(finishProgrammatic, SETTLE_MS);
		};

		const finishProgrammatic = () => {
			programmaticTarget = null;
			pageIndex = leftToIndex(root.scrollLeft);
			updateUI();
		};

		prevBtn.addEventListener("click", () => scrollToIndex(pageIndex - 1));
		nextBtn.addEventListener("click", () => scrollToIndex(pageIndex + 1));

		let raf = null;
		root.addEventListener(
			"scroll",
			() => {
				if (programmaticTarget !== null) {
					if (Math.abs(root.scrollLeft - programmaticTarget) <= EPS)
						return;
					if (settleTimer) clearTimeout(settleTimer);
					settleTimer = setTimeout(finishProgrammatic, SETTLE_MS);
					return;
				}

				if (raf) return;
				raf = requestAnimationFrame(() => {
					raf = null;
					const i = leftToIndex(root.scrollLeft);
					if (i !== pageIndex) {
						pageIndex = i;
						updateUI();
					}
				});
			},
			{ passive: true },
		);

		const onResize = () => {
			pageIndex = leftToIndex(root.scrollLeft);
			updateUI();
			scope.classList.toggle("no-scroll", maxScroll() === 0);
		};
		window.addEventListener("resize", onResize);

		onResize();
	}
});
